
import * as React from 'react'

import { addSpacersToFeatures, ConditionsList, ExtraSection, FeatureList } from '../index'
import { CardGroup, ContentCard, Heading, Text } from '@/components/ui'

export default function SignupPlans ({ plans }) {
    // Get free plan from plans array
    const freePlan = plans.find(plan => plan.slug === 'free')
    // Filter out essentials plan for signup view
    const signupPlans = plans.filter(plan => plan.slug !== 'essentials' && plan.slug !== 'free')

    return (
        <CardGroup columns={4}>
            <ContentCard tone="primary">
                <div className="tw-flex tw-h-full tw-flex-col">
                    <div className="tw-flex tw-flex-col tw-items-center tw-mb-4">
                        <Heading as="span" tone="inherit" variant="title-sm">{freePlan.key}</Heading>
                        <Heading as="span" tone="inherit" variant="display">€{freePlan.price}/mo</Heading>
                        <div className="tw-opacity-0"><Text tone="inherit" variant="caption">{i18next.t('plans.starting_at')}</Text></div>
                    </div>
                    <div className="tw-flex tw-flex-col">
                        <div>
                            <div className="tw-mb-2"><Text as="p" tone="inherit" variant="body-sm"><strong>{i18next.t('plans.features_label')}</strong></Text></div>
                            <FeatureList features={addSpacersToFeatures(freePlan.features, plans)} iconTone="background"/>
                        </div>
                        <div className="tw-border-t tw-border-solid tw-border-background/15 tw-my-3" />
                        <div>
                            <ConditionsList conditions={freePlan.conditions} iconTone="background"/>
                        </div>
                    </div>
                    <ExtraSection extra={freePlan.extra}/>
                </div>
            </ContentCard>
            {signupPlans.map((plan) => (
                <ContentCard key={plan.key}>
                    <div className="tw-flex tw-h-full tw-flex-col">
                        <div className="tw-flex tw-flex-col tw-items-center tw-mb-4">
                            <div className="tw-text-primary"><Heading as="span" tone="inherit" variant="title-sm">{plan.key}</Heading></div>
                            <Heading as="span" variant="display">€{plan.price}/mo</Heading>
                            <Text tone="muted" variant="caption">{i18next.t('plans.starting_at')}</Text>
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <div>
                                <div className="tw-mb-2"><Text as="p" variant="body-sm"><strong>{i18next.t('plans.features_label')}</strong></Text></div>
                                <FeatureList features={addSpacersToFeatures(plan.features, plans)} iconTone="primary"/>
                            </div>
                            <div className="tw-border-t tw-border-solid tw-border-primary tw-my-3" />
                            <div>
                                <ConditionsList conditions={plan.conditions} iconTone="primary"/>
                            </div>
                        </div>
                        <div className="tw-text-primary"><ExtraSection extra={plan.extra}/></div>
                    </div>
                </ContentCard>
            ))}
        </CardGroup>
    )
}
